<style scoped>
#search_results {
	padding: 5px;
	padding-top: 10px;
}
</style>

<template>
	<div id="search_results">
		<v-alert type="error" v-if="errormsg != ''">{{
			errormsg
		}}</v-alert>

		<div v-if="!loading">
			<jb-data-grid
				v-if="jobs.length > 0"
				:selected_id="selected_id"
				:can_change_columns="can_change_columns"
				:height="table_height"
				:records="jobs"

				:show_columns="show_columns"
				:available_columns="available_columns"
				@columns_changed="columns => $emit('columns_changed', columns)"

				:can_sort_columns="can_sort_columns"
				:sort_columns="sort_columns"
				@sort_changed="columns => $emit('sort_changed', columns)"

				@row_clicked="job => $emit('click_job', job)"
			/>
		</div>

		<div v-if="loading">
			<v-skeleton-loader
				type="list-item-avatar-two-line"
				width="100%"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="list-item-avatar-two-line"
				width="100%"
			></v-skeleton-loader>				
		</div>
	</div>
</template>

<script>
import jbdatagrid from "@/components/controls/jbdatagrid";

export default {
	props: {
		selected_id: {
			type: Number,
			default: 0
		},
		can_change_columns: { // user is allowed to change the display columns
			type: Boolean,
			default: true
		},
		can_sort_columns: { // user is allowed to change the sort columns
			type: Boolean,
			default: false
		},
		table_height: {
			type: Number,
			default: undefined
		},
		show_columns: {
			type: Array,
			default: function() { return [
				'code',
				'short',
				'job_type.name',
				'status.name',
				'client.name',
				'perc_traffic_used'
			] }
		},
		sort_columns: {
			type: Array,
			default: function() { return [
				'code',
			] }
		},
	},
	data() {
		return {
			loading: false,
			iteration: 1,
			errormsg: '',
			search: {
				from_code: "",
				to_code:"",
				short:"",
				job_types: [],
				statusses: [],
				client: 0,
				status_groups: [ 0, 1, 2 ],
				invoice_from: null,
				invoice_to: null,
				show_columns: [],
				sort_columns: [],
			},
			jobs: [],
			available_columns: [
				{
					type: 'span',
					label: 'Job no.',
					name: 'code'
				},
				{
					type: 'span',
					label: 'Title',
					name: 'short'
				},
				{
					type: 'span',
					label: 'Job type',
					name: 'job_type.name'
				},
				{
					type: 'span',
					label: 'Job status',
					name: 'status.name'
				},
				{
					type: 'href',
					label: 'Client',
					name: 'client.name',
					uri: 'client.uri'
				},
				{
					type: 'href',
					label: 'Contact',
					name: 'contact.name',
					uri: 'contact.uri'
				},
				{
					type: 'span',
					label: 'Division',
					name: 'division.name',
				},
				{
					type: 'href',
					label: 'Account executive',
					name: 'acc_exec.name',
					uri: 'acc_exec.uri'
				},
				{
					type: 'href',
					label: 'Account director',
					name: 'acc_dir.name',
					uri: 'acc_dir.uri'
				},
				{
					type: 'perc',
					label: '% Traffic used',
					name: 'perc_traffic_used',
					overcolor: '#FF4040' /* red */
				},
				{
					type: 'perc',
					label: '% Budget billed',
					name: 'perc_quoted_billed',
					overcolor: '#81CC00' /* green */
				},
				{
					type: 'perc',
					label: '% Value billed',
					name: 'perc_value_billed',
					overcolor: '#81CC00' /* green */
				},
				{
					type: 'value',
					label: 'Total value',
					name: 'total_value'
				},
				{
					type: 'value',
					label: 'Total invoiced',
					name: 'total_invoiced'
				}
			]
		}
	},
	components: {
		'jb-data-grid': jbdatagrid
	},
	methods: {
		default_columns() { 
			return [
				'code',
				'short',
				'job_type.name',
				'status.name',
				'client.name',
				'perc_traffic_used'
			] 
		},
		date_to_ymd(date) {
			let year = date.getFullYear();
			let month = date.getMonth() + 1; // 0 - 11
			let day = date.getDate();

			let date_fmt = "" + year; // change it to a string!
			if (month < 10) date_fmt += "0";
			date_fmt += month; // date_fmt is already a string so this should do a string add, not math
			if (day < 10) date_fmt += "0";
			date_fmt += day; // date_fmt is already a string so this should do a string add, not math

			return date_fmt;
		},
		perform_search(new_search) {
			// We need to find out how to cancel any already running search...

			let self = this; // make sure we can access this inside of our promisses
			this.loading = true;

			// it is possible for the user to execute a new search while the previous one is still running
			// this allows us to ignore those results.
			this.iteration += 1;
			let search_iteration = this.iteration

			// copy our search
			this.search = {... new_search};

			// build our url parameters
			let params = new Array();
			if (this.search.from_code != '') params.push("from_code=" + encodeURIComponent(this.search.from_code));
			if (this.search.to_code != '') params.push("to_code=" + encodeURIComponent(this.search.to_code));
			if (this.search.short != '') params.push("short=" + encodeURIComponent(this.search.short));
			if (this.search.job_types != '') params.push("job_types=" + encodeURIComponent(this.search.job_types));
			if (this.search.statusses != '') params.push("statusses=" + encodeURIComponent(this.search.statusses));
			if (this.search.status_groups != '') params.push("status_groups=" + encodeURIComponent(this.search.status_groups));
			if (this.search.clients != '') params.push("client=" + encodeURIComponent(this.search.clients));
			if (this.search.invoice_from != null) params.push("invoice_from=" + this.date_to_ymd(this.search.invoice_from));
			if (this.search.invoice_to != null) params.push("invoice_to=" + this.date_to_ymd(this.search.invoice_to));
			params.push('is_lookup' + '=' + encodeURIComponent(false));

			// build our url, we have to add url escaping here!
			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			// console.log(url);

			// look into escaping our url thingies
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					if (search_iteration == self.iteration) {
						// this is the result of the last search we've started, lets process it.
						let json = d.data;

						// For some reason axios isn't always converting our data
						if ((typeof json) == "string") {
							json = JSON.parse(json);
						}

						if (json.status == "OK") {
							// console.log("got data");

							self.jobs = json.data;
							self.errormsg = '';
						} else {
							self.errormsg = json.reason;
						}
					} else {
						// this is the result for an older search we've started, we can ignore it
						console.log("Received result set for previous search - ignored")
					}
				})
				.catch(function(e) {
					if (search_iteration == self.iteration) {
						// this is the error for the last search we've started, lets show it.
						self.errormsg = e.message;
					} else {
						// this is an error for an older search that was stil running, we can ignore it
						console.log("Received error for previous search - ignored")
					}
					console.log(e);
				})
				.finally(function() {
					if (search_iteration == self.iteration) {
						self.loading = false;

						self.$emit('content_changed');
					} else {
						// this was the result or error for a search started before the last search we did
						// we can safely ignore it. If the last search is still going loading is still true
						// if the latest search has already finished it is already being displayed and loading is already false.
					}
				});	
		},
		clear_results() {
			this.jobs = [];
		},
	},
}
</script>
